import { sharedService } from "@/modules/shared/store/services/shared-service";
import { populateLenderOfferTypes } from "@/redux/reducers/lenderOfferTypes";

const getLenderOfferTypes = sharedService.injectEndpoints({
  endpoints: builder => ({
    getLenderOfferTypes: builder.query({
      query: () => "parameters/lender-offer-types",
      transformResponse: response => response.items,
      providesTags: ["LenderOfferTypes"],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(populateLenderOfferTypes(data));
        } catch { /* handled by RTK Query error state */ }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetLenderOfferTypesQuery } = getLenderOfferTypes;

